module.exports = __webpack_public_path__ + "static/media/users.a3a812e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/users.png
// module id = 1102
// module chunks = 0